export default {"src":"/_next/static/media/model-integrity-audits.5792c90b.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};